import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../helpers/firebase';

const year = new Date().getFullYear().toString();
const getImageUrl = async filename => getDownloadURL(ref(storage, `images/${year}/${filename}`))
  .then(url => url)
  .catch(() => '');

export default getImageUrl;